<div
  class="calendar"
  [class.full-width]="fullWidth"
  [attr.data-size]="size"
  [attr.data-variant]="variant"
  [attr.data-view]="view"
  [attr.data-disabled]="disabled"
>
  <!-- Full skeleton overlay -->

  @if (showLoading && loadingScope === 'full') {
    <div class="calendar-skeleton-overlay calendar-skeleton-overlay--full">
      <div class="skeleton-header">
        <div class="skeleton-block skeleton-nav"></div>
        <div class="skeleton-block skeleton-month-label"></div>
        <div class="skeleton-block skeleton-nav"></div>
      </div>
      <div class="skeleton-weekdays">
        @for (_ of weekdayNames; track $index) {
          <div class="skeleton-block skeleton-weekday"></div>
        }
      </div>
      <div class="skeleton-block skeleton-dates-area"></div>
    </div>
  }

  <!-- Calendar Header -->

  @if (showHeader) {
    <div class="calendar-header-wrapper">
      @if (showLoading && loadingScope === 'navigation') {
        <div
          class="calendar-skeleton-overlay calendar-skeleton-overlay--navigation"
        >
          <div class="skeleton-header">
            <div class="skeleton-block skeleton-nav"></div>
            <div class="skeleton-block skeleton-month-label"></div>
            <div class="skeleton-block skeleton-nav"></div>
          </div>
        </div>
      }
      <umss-date-picker-header
        [currentMonth]="currentMonthNumber"
        [currentYear]="currentYear"
        [locale]="locale"
        layout="1Month"
        variant="Default"
        [size]="headerSize"
        [disabled]="disabled || (showLoading && loadingScope === 'navigation')"
        [minDate]="minDate"
        [maxDate]="maxDate"
        (previousMonth)="onPreviousMonth()"
        (nextMonth)="onNextMonth()"
      />
    </div>
  }

  <!-- Calendar Grid -->
  <div class="calendar-grid">
    <!-- Weekday Headers -->
    <div class="calendar-weekdays">
      @for (weekday of weekdayNames; track $index) {
        <div class="calendar-weekday">
          {{ weekday }}
        </div>
      }
    </div>

    <!-- Calendar Days -->
    <div class="calendar-days-wrapper" [@horizontalSlide]="calendarAnimIndex()">
      @for (entry of calendarMonthEntries(); track entry) {
        <div class="slide-block" style="width: 100%">
          @if (showLoading && loadingScope === 'dates') {
            <div
              class="calendar-skeleton-overlay calendar-skeleton-overlay--dates"
            >
              <div class="skeleton-block skeleton-dates-area"></div>
            </div>
          }
          <div class="calendar-days">
            @for (day of calendarDays; track trackByDate($index, day)) {
              @if (hideOutsideDays && !day.isCurrentMonth) {
                <div class="calendar-day-wrapper"></div>
              } @else {
                <div
                  class="calendar-day-wrapper"
                  [umssTooltip]="
                    day.isDisabled && day.isCurrentMonth && disabledDateTooltip
                      ? disabledDateTooltip
                      : ''
                  "
                  tooltipPosition="top"
                  tooltipSize="small"
                  [tooltipDelay]="0"
                >
                  <button
                    type="button"
                    class="calendar-day"
                    [class.other-month]="!day.isCurrentMonth"
                    [class.current-month]="day.isCurrentMonth"
                    [class.today]="day.isToday"
                    [class.selected]="isDateSelected(day)"
                    [class.marked]="day.isMarked"
                    [class.weekend]="day.isWeekend"
                    [class.visually-disabled]="
                      day.isDisabled &&
                      (allowDisabledDateClick ||
                        isClickableDisabledDate(day.date))
                    "
                    [disabled]="
                      day.isDisabled &&
                      !allowDisabledDateClick &&
                      !isClickableDisabledDate(day.date)
                    "
                    [attr.aria-label]="
                      day.date.toLocaleDateString(locale, {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })
                    "
                    [attr.aria-selected]="isDateSelected(day)"
                    (click)="onDayClick(day)"
                    (mouseenter)="onDayHover(day)"
                    (mouseleave)="onDayHover(null)"
                  >
                    <span class="day-number">{{ day.dayNumber }}</span>

                    <!-- Marker for marked dates -->
                    @if (day.isMarked && markerType === 'dot' && !showLoading) {
                      <span class="day-markers">
                        @for (color of getColoredDots(day.date); track color) {
                          <span
                            class="day-marker"
                            [style.background]="color"
                          ></span>
                        }
                      </span>
                    }

                    @if (
                      day.isMarked && markerType === 'badge' && !showLoading
                    ) {
                      <span class="day-badge" [style.background]="markerColor">
                      </span>
                    }
                  </button>
                </div>
              }
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
